import { makeStyles } from '@mui/styles';
import { styles } from '@tcs/create-account/utils/theme';

export const useStyles = makeStyles({
  header: {
    position: 'fixed',
    left: 0,
    right: 0,
    background: 'linear-gradient(160deg, #2c404f -20%, #7e98a8 140%)',
    boxShadow: '0 20px 40px 0 rgb(0 0 0 / 25%)',
    zIndex: 100,
  },
  container: {
    padding: `${styles.spacing(2)}px ${styles.spacing(8)}px`,
    transition: styles.transitions.regular(['padding']),
    [styles.breakpoints.down('lg')]: {
      padding: `${styles.spacing(2)}px ${styles.spacing(5)}px`,
    },
    [styles.breakpoints.down('md')]: {
      padding: `${styles.spacing(2)}px ${styles.spacing(4)}px`,
    },
  },
  topLine: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: `${styles.spacing(1)}px`,
    [styles.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  topLink: {
    marginLeft: `${styles.spacing(3)}px`,
    color: styles.palette.text.inverse,
    textDecoration: 'none',
    transition: styles.transitions.regular(['color']),
    '&:hover': {
      color: styles.palette.text.secondary,
    },
  },
  mainLine: {
    display: 'flex',
    alignItems: 'center',
  },
  logos: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginRight: `${styles.spacing(3)}px`,
  },
  logoLink: {
    padding: `${styles.spacing(1)}px`,
    marginRight: `${styles.spacing(4)}px`,
    boxSizing: 'border-box',
    transition: styles.transitions.regular(['margin']),
    [styles.breakpoints.down('md')]: {
      marginRight: `${styles.spacing(3)}px`,
    },
    [styles.breakpoints.down('sm')]: {
      marginRight: `${styles.spacing(2)}px`,
    },
  },
  logo: {
    display: 'block',
    maxHeight: 45,
    width: 'auto',
    transition: styles.transitions.regular(['max-height']),
    [styles.breakpoints.down('md')]: {
      maxHeight: 35,
    },
    [styles.breakpoints.down('sm')]: {
      maxHeight: 30,
    },
  },
  mainLogo: {
    width: 175,
    height: 45,
  },
  headerGap: {
    height: 95,
    [styles.breakpoints.down('md')]: {
      height: 75,
    },
    [styles.breakpoints.down('sm')]: {
      height: 70,
    },
  },
  bannerGap: {
    height: 70,
    [styles.breakpoints.down('md')]: {
      height: 64,
    },
    [styles.breakpoints.down('sm')]: {
      height: 60,
    },
  },
  versionTag: {
    position: 'fixed',
    top: 0,
    left: 0,
    padding: 2,
    backgroundColor: styles.palette.background.dark,
    color: styles.palette.text.secondary,
    borderRadius: 2,
    zIndex: 101,
  },
});
